import { render, staticRenderFns } from "./workGroupTree.vue?vue&type=template&id=5245c2dc&scoped=true&"
import script from "./workGroupTree.vue?vue&type=script&lang=js&"
export * from "./workGroupTree.vue?vue&type=script&lang=js&"
import style0 from "./workGroupTree.vue?vue&type=style&index=0&id=5245c2dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5245c2dc",
  null
  
)

export default component.exports